export const POPULAR_NEWS_REQUEST = "POPULAR_NEWS_REQUEST"
export const POPULAR_NEWS_SUCCESS = "POPULAR_NEWS_SUCCESS"
export const POPULAR_NEWS_FAIL = "POPULAR_NEWS_FAIL"